<template>
  <div v-if="current" class="announcement-banner" :class="severityClass">
    <div class="announcement-banner__header">
      <span class="announcement-banner__title">{{ current.title }}</span>
      <div class="announcement-banner__meta">
        <span class="announcement-banner__dates">{{ dateRangeText }}</span>
        <VaButton
          preset="secondary"
          icon-right="close"
          size="small"
          color="textPrimary"
          class="announcement-banner__close"
          :aria-label="t('MetabolicLang.common.Close')"
          @click="store.dismissCurrent()"
          >{{ t('MetabolicLang.common.Close') }}</VaButton
        >
      </div>
    </div>
    <SafeHtml class="announcement-banner__description" :html="current.description" allow-link-target />
    <div v-if="store.announcements.length > 1" class="announcement-banner__dots">
      <span
        v-for="(announcement, index) in store.announcements"
        :key="announcement.id"
        class="announcement-banner__dot"
        :class="{ 'announcement-banner__dot--active': index === store.activeIndex }"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useAnnouncementStore } from '@/stores/announcement-store'
import { AnnouncementSeverity } from '@/enums'
import { formatAnnouncementDateRange } from '@/services/date'
import SafeHtml from '@/components/SafeHtml.vue'
import { VaButton } from 'vuestic-ui'

const { t } = useI18n()
const store = useAnnouncementStore()

const current = computed(() => store.current)

const severityClass = computed(() => {
  switch (current.value?.severity) {
    case AnnouncementSeverity.Critical:
      return 'announcement-banner--critical'
    case AnnouncementSeverity.Warning:
      return 'announcement-banner--warning'
    default:
      return 'announcement-banner--info'
  }
})

const dateRangeText = computed(() => {
  if (!current.value) return ''
  return formatAnnouncementDateRange(current.value.eventStartDate, current.value.eventEndDate)
})
</script>
